<form #feedbackExecutionForm="ngForm" novalidate>
<div class="container">
    <div class="row" *ngIf="usersToEditFeedback?.length > 0">
        <div class="col-xs-12 px-0 mt-4">
            <div *ngIf="!loadingUsers" class="alert alert-info">
                <label for="participants">Feedback can be edited by:
                    <span *ngIf="feedbackReadOnly">
                        <b>{{enabledEditForUser?.displayName}}</b>
                        <button type="button" class="btn btn-primary ml-2" (click)="requestPermissionToEdit()">
                            Request permission to edit
                        </button>
                    </span>
                </label>
                <select *ngIf="!feedbackReadOnly" class="form-control d-inline-block width-50" name="participants" id="participants"
                    [(ngModel)]="enableEditForAttendeeId" (ngModelChange)="onUserWhoCanEditFeedbackChange()">
                    <option *ngFor="let user of usersToEditFeedback" [value]="user.attendeeId">{{user.displayName}}</option>
                </select>
                <i class="fas fa-redo ml-2 cursor-pointer" (click)="setFeedbackEnabledAttendeeId()" tooltip="Refresh users" container="body"></i>
            </div>
            <div *ngIf="loadingUsers" class="alert alert-info">
                <div class="skeleton-paragraph skeleton-loading" style="width: 40%; margin: 0 auto;"></div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="feedbackType != 'Outreach'">
        <div class="col-xs-12">
            <h4>
                <span>{{ feedbackTypeLabel }} </span>
                <span [hidden]="!loadingJobMatchDetailsFlag" style="padding-left: 10px;">
                    <span class="skeleton-paragraph skeleton-loading" style="display: inline-block; width: 200px; height: 14px; vertical-align: middle;"></span>
                </span>
                <span [hidden]="loadingJobMatchDetailsFlag">
                    '<span class="emerald">{{candidateJobMatch.name}}</span>' for the role of
                    '<span class="emerald">{{candidateJobMatch.jobMatchTitle}}</span>'
                    <app-info-icon *ngIf="candidateJobMatch.requisitionNote" style="position:relative;bottom:1px;font-size:13px;"
                        [info]="candidateJobMatch.requisitionNote"
                        infoTitle="Requisition Info">
                    </app-info-icon>

                    <span *ngIf="candidateJobMatch.jobMatchClientName != null">at '<span class="emerald">{{ candidateJobMatch.jobMatchClientName }}</span>'</span>
                    <app-info-icon *ngIf="candidateJobMatch.clientNote" style="position:relative;bottom:1px;font-size:13px;"
                        [info]="candidateJobMatch.clientNote"
                        infoTitle="Info">
                    </app-info-icon>
                     <span [hidden]="!showChosenUserDetails">by -</span>
                </span>
            </h4>
        </div>
    </div>
    <div class="row" [hidden]="!loadingJobMatchDetailsFlag">
        <div class="col-xs-12 text-center" style="padding-top: 10px">
            <div class="skeleton-paragraph skeleton-loading" style="width: 60%; margin: 0 auto 10px;"></div><div class="skeleton-paragraph skeleton-loading" style="width: 40%; margin: 0 auto;"></div>
        </div>
    </div>
    <div class="row" *ngIf="feedbackType == 'Screening' && showChosenUserDetails" style="margin-top: 10px;">
        <div class="col-xs-12" *ngIf="userList.length == 1">
            <h4>{{userList[0].firstname}}<span *ngIf="userList[0].lastname != null">{{" " + userList[0].lastname}}</span></h4>
        </div>
        <ng-container *ngIf="userList.length > 1">
        <div class="col-xs-12 col-sm-6 col-md-4" *ngFor="let user of userList">
            <div class="radio" style="display: inline;">
                <input type="radio" name="chosenUser" id="chosenUser-{{user.id}}" [value]="user"
                       (click)="feedbackEntityChanged()" [(ngModel)]="chosenUser">
                <label for="chosenUser-{{user.id}}">
                    {{user.firstname}}<span *ngIf="user.lastname != null">{{" " + user.lastname}}</span>
                </label>
            </div>
        </div>
        </ng-container>
    </div>
    <div class="row" *ngIf="(feedbackType == 'Interview' || feedbackType == 'PhoneScreen' || feedbackType == 'RecruiterScreening') && showMeetingsFlag && !loadingFeedbackOptionsFlag" style="margin-top: 10px;">
        <div class="col-xs-12" *ngIf="meetingsList.length == 1">
            <h4>
                <span [ngClass]="{'feedback-disabled-meeting-label': !meetingsList[0].editableFlag}">
                    <span [tooltip]="meetingsList[0].userNamesLabel">
                        <span>{{ meetingsList[0].userNamesLabel | slice:0:70 }}</span>
                        <span *ngIf="meetingsList[0].userNamesLabel.length > 70">..</span>
                    </span>
                    <span> - </span>
                    <span>{{ meetingsList[0].scheduledTime }}</span>
                </span>
                <span class="{{meetingsList[0].statusClass}} ml-2 mr-1" [tooltip]="meetingsList[0].statusLabel"></span>
                <a *ngIf="context != 'conference' && meetingsList[0].status != 'COMPLETED'" class="{{meetingsList[0].meetingModeClass}} mr-1" href="{{meetingsList[0].meetingUrl}}" tooltip="Start Meeting" target="_blank"></a>
                <a *ngIf="context != 'conference'" class="fas fa-book-open" tooltip="View Candidate Booklet" container="body" (click)="viewCandidateBooklet()"></a>
            </h4>
        </div>
        <ng-container *ngIf="meetingsList.length > 1">
        <div class="col-xs-12" *ngFor="let meeting of meetingsList">
            <div class="radio" style="display: inline;">
                <input type="radio" name="chosenMeeting" id="chosenMeeting-{{meeting.id}}" [value]="meeting"
                       (click)="feedbackEntityChanged()" [(ngModel)]="chosenMeeting" [disabled]="!meeting.editableFlag">
                <label for="chosenMeeting-{{meeting.id}}">
                    <span [ngClass]="{'feedback-disabled-meeting-label': !meeting.editableFlag}">
                        <span [tooltip]="meeting.userNamesLabel">
                            <span>{{ meeting.userNamesLabel | slice:0:70 }}</span>
                            <span *ngIf="meeting.userNamesLabel.length > 70">..</span>
                        </span>
                        <span> - </span>
                        <span>{{ meeting.scheduledTime }}</span>
                    </span>
                    <span class="{{meeting.statusClass}} mr-1" [tooltip]="meeting.statusLabel"></span>
                    <a *ngIf="meeting.status !== 'COMPLETED'" class="{{meeting.meetingModeClass}} mr-1" tooltip="Start Meeting" (click)="openConference(meeting)"></a>
                    <span *ngIf="meeting.status == 'COMPLETED'" class="{{meeting.meetingModeClass}} mr-1"></span>
                    <a class="fas fa-book-open" tooltip="View Candidate Booklet" container="body" (click)="viewCandidateBooklet(meeting)"></a>
                </label>
            </div>
        </div>
        </ng-container>
    </div>
    <div class="row" [hidden]="!loadingFeedbackOptionsFlag">
        <div class="col-xs-12 text-center" style="padding-top: 20px">
            <div class="skeleton-paragraph skeleton-loading" style="width: 60%; margin: 0 auto 10px;"></div><div class="skeleton-paragraph skeleton-loading" style="width: 40%; margin: 0 auto;"></div>
        </div>
    </div>
    <div class="row">
        <div class="col-xs-12" *ngIf="feedbackType != 'Outreach'">
            <hr/>
        </div>
    </div>
    <div class="row" *ngIf="feedbackType == 'Screening' && (screeningFeedbackStartedData != null)">
        <div classs="col-xs-12">
            <div style="padding-left: 10px;">
                <i class="fa fa-info-circle"></i>
                <span style="padding-left: 5px;">
                    Screening Feedback was started by '<span class="emerald">{{screeningFeedbackStartedData.recruiterName}}</span>' on '<span class="emerald">{{screeningFeedbackStartedData.startDateTime | fourDotFiveTimeStampFormatPipe}}</span>'
                </span>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="feedbackType == 'Screening' && (screeningFeedbackStartedData != null)">
        <div class="col-xs-12">
            <hr/>
        </div>
    </div>
    <div class="row" *ngIf="(feedbackType == 'Interview' || feedbackType == 'PhoneScreen' || feedbackType == 'RecruiterScreening') && showMeetingsFlag && !loadingFeedbackOptionsFlag && !editableMeetingsExistFlag">
        <div class="col-xs-12 text-center" style="padding-top: 10px; padding-bottom: 10px">
            <h4>{{noEditableMeetingsLabel}}
            </h4>
        </div>
    </div>
    <div class="row">
        <div class="col-xs-12" *ngIf="!showMeetingLink && !loadingFeedbackOptionsFlag">
            <div class="row">
                <div class="col-xs-12">
                    <div *ngIf="displayQuestions && userHasAccessToFeedback && feedbackType != 'Outreach'">
                        <div class="col-xs-12 d-flex justify-content-end mb-3" *ngIf="showInterested">
                            <button class="btn btn-primary" [disabled]="feedbackReadOnly" (click)="markAllJobsAsInterested()">Mark All as Interested</button>
                        </div>
                        <div class="">
                            <table width="100%" class="table-bordered feedback-requisitions-table">
                                <thead>
                                <tr>
                                    <th><span>Requisition</span></th>
                                    <th>
                                        <span *ngIf="!isCorporateFlag">Client Name</span>
                                        <span *ngIf="isCorporateFlag">BU Name</span>
                                    </th>
                                    <th><span>Job Title</span></th>
                                    <th *ngIf="feedbackType == 'PhoneScreen' || feedbackType == 'Interview' || feedbackType == 'RecruiterScreening'" class="job-match-details-col"><span>Job Match Details</span></th>
                                    <th><span>Score</span></th>
                                    <th><span>Recruiters</span></th>
                                    <th><span>Match Date</span></th>
                                    <th [hidden]="!showInterested"><span>Interested</span></th>

                                </tr>
                                </thead>
                                <ng-container *ngIf="clientOrBuExists">
                                <tbody *ngFor="let clientList of recruiterqns.sortedClientList">
                                    <tr *ngFor="let jmId of recruiterqns.clientListJobMatchDetails[clientList]" [ngClass]="{'interested-job': recruiterqns.jobDetails[jmId].interested}">
                                    <td>
                                        <i *ngIf="jobMatchId === jmId" class="fas fa-arrow-circle-right green" tooltip="Current Job" container="body"></i>
                                        <span [ngClass]="{'pl-4' : jobMatchId !== jmId}">{{ recruiterqns.jobDetails[jmId].reqNumber }}</span>
                                    </td>
                                    <td>
                                        <span *ngIf="recruiterqns.jobDetails[jmId].clientName !== null">{{ recruiterqns.jobDetails[jmId].clientName }}</span>
                                        <span *ngIf="recruiterqns.jobDetails[jmId].sharedJob && !isCorporateFlag">
                                            <span *ngIf="recruiterqns.jobDetails[jmId].clientName !== null"> at </span>
                                                {{recruiterqns.jobDetails[jmId].corporateName}}
                                        </span>
                                        <app-info-icon *ngIf="recruiterqns.jobDetails[jmId].clientNote"
                                            [info]="recruiterqns.jobDetails[jmId].clientNote"
                                            infoTitle="Info">
                                        </app-info-icon>
                                    </td>
                                    <td>
                                        <a (click)="!feedbackReadOnly && viewJobProfile(recruiterqns.jobDetails[jmId].jobId)">
                                            {{ recruiterqns.jobDetails[jmId].title }}
                                        </a>
                                        <app-info-icon *ngIf="recruiterqns.jobDetails[jmId].requisitionNote"
                                            [info]="recruiterqns.jobDetails[jmId].requisitionNote"
                                            infoTitle="Requisition Info">
                                        </app-info-icon>
                                        <div style="font-size: 0.8em;">
                                            <span>{{recruiterqns.jobDetails[jmId].jobType}}</span>
                                            <span *ngIf="recruiterqns.jobDetails[jmId].contractDuration">
                                                ({{recruiterqns.jobDetails[jmId].contractDuration | contractDurationPipe}})
                                            </span>
                                        </div>
                                    </td>
                                    <td *ngIf="feedbackType == 'PhoneScreen' || feedbackType == 'Interview' || feedbackType == 'RecruiterScreening'">
                                        <span class="ml-1 cursor-pointer">
                                            <app-candidate-card-icons
                                                context="candidateCompare"
                                                [candidate]="candidateJobMatch"
                                                [requisitionSponsorships]="requisitionSponsorships"
                                                [candidateAdditionalDetails]="candidateJobMatch.candidateAdditionalDetails"
                                                [candidateSalaryDurationOptions]="salaryDurationOptions"
                                                [jobTypeList]="jobTypeList">
                                            </app-candidate-card-icons>
                                        </span>
                                    </td>
                                    <td>
                                        <span *ngIf="recruiterqns.jobDetails[jmId].score != 0">
                                            {{ recruiterqns.jobDetails[jmId].score }}
                                        </span>
                                        <span *ngIf="recruiterqns.jobDetails[jmId].score == 0">
                                            N/A
                                        </span>

                                    </td>
                                    <td>
                                        <div *ngIf="recruiterqns.jobDetails[jmId].assignedRecruiterName!==null">
                                            <span
                                                [tooltip]="recruiterqns.jobDetails[jmId].assignedRecruiterName">
                                                {{recruiterqns.jobDetails[jmId].assignedRecruiterName}}
                                            </span>
                                            <sup tooltip="Assigned Recruiter of Job Match" class="fa fa-star emerald"
                                                style="font-size: 0.7em">
                                            </sup>
                                        </div>
                                        <div *ngFor="let recruiterName of recruiterqns.jobDetails[jmId].recruiterNames">
                                            <span [tooltip]="recruiterName">
                                                {{recruiterName}}
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        {{ recruiterqns.jobDetails[jmId].matchDate | fourDotFiveDateFormatPipe }}
                                    </td>
                                    <td [hidden]="!showInterested" align="center" style="width:135px;">
                                        <div class="pt-3">
                                            <div class="comp-management-radio"
                                                style="display: inline">
                                                <input type="radio" name="checkbox-inl-{{jmId}}-yes" id="checkbox-inl-{{jmId}}-yes" [value]="true"
                                                    [disabled]="feedbackReadOnly"
                                                    (ngModelChange)="filterByInterested()"
                                                    [(ngModel)]="recruiterqns.jobDetails[jmId].interested">
                                                <label for="checkbox-inl-{{jmId}}-yes">
                                                    Yes
                                                </label>
                                            </div>
                                            <div class="comp-management-radio"
                                                style="display: inline;">
                                                <input type="radio" name="checkbox-inl-{{jmId}}-no" id="checkbox-inl-{{jmId}}-no" [value]="false"
                                                    [disabled]="feedbackReadOnly"
                                                    (ngModelChange)="filterByInterested()"
                                                    [(ngModel)]="recruiterqns.jobDetails[jmId].interested">
                                                <label for="checkbox-inl-{{jmId}}-no">
                                                    No
                                                </label>
                                            </div>
                                        </div>
                                    </td>

                                </tr>
                                </tbody>
                                </ng-container>
                                <tbody *ngIf="!clientOrBuExists">
                                    <tr *ngFor="let jobMatch of recruiterqns.jobDetails | keyvalue">
                                        <td>
                                            {{ jobMatch.value.reqNumber }}
                                        </td>
                                        <td>
                                            N/A
                                        </td>
                                        <td>
                                            {{ jobMatch.value.title }}
                                            <app-info-icon *ngIf="jobMatch.value.requisitionNote"
                                                [info]="jobMatch.value.requisitionNote"
                                                infoTitle="Requisition Info">
                                            </app-info-icon>
                                            <div style="font-size:0.8em">
                                                <span>{{jobMatch.value.jobType}}</span>
                                                <span *ngIf="jobMatch.value.contractDuration">
                                                    ({{jobMatch.value.contractDuration | contractDurationPipe}})
                                                </span>
                                            </div>
                                        </td>
                                        <td>
                                            <span *ngIf="jobMatch.value.score != 0">
                                                {{ jobMatch.value.score }}
                                            </span>
                                            <span *ngIf="jobMatch.value.score == 0">
                                                N/A
                                            </span>
                                        </td>
                                        <td>
                                            <span *ngIf="jobMatch.value.recruiterName != null">
                                                {{ jobMatch.value.recruiterName }}
                                            </span>
                                            <span *ngIf="jobMatch.value.recruiterName == null">
                                                N/A
                                            </span>
                                        </td>
                                        <td>
                                            {{ jobMatch.value.matchDate | fourDotFiveDateFormatPipe }}
                                        </td>
                                        <td [hidden]="!showInterested" style="vertical-align: top; padding-bottom: 10px" align="center">
                                            <div class="checkbox-nice checkbox-inline">
                                                <input type="checkbox" id="checkbox-inl-{{jobMatch.value.jobMatchId}}" [(ngModel)]="jobMatch.value.interested" [disabled]="feedbackReadOnly" (ngModelChange)="filterByInterested()" name="checkbox-inl-{{jobMatch.value.jobMatchId}}" checked/>
                                                <label for="checkbox-inl-{{jobMatch.value.jobMatchId}}"></label>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" [hidden]="!loadingFeedbackDetailsFlag">
                <div class="col-xs-12 text-center" style="padding-top: 20px">
                    <div class="skeleton-paragraph skeleton-loading" style="width: 60%; margin: 0 auto 10px;"></div><div class="skeleton-paragraph skeleton-loading" style="width: 40%; margin: 0 auto;"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <div *ngIf="displayQuestions && !loadingFeedbackDetailsFlag && userHasAccessToFeedback && !isCorporateAccessingVendorCandidate" style="margin-top: 5px;">
                        <div class="panel-group accordion" id="accordion">
                            <div class="panel panel-default"
                                [ngClass]="{'disablescreen row-disabled': feedbackType == 'Outreach' && disableFeedbackQuestions }">
                                <header class="panel-heading">
                                    <h4 class="panel-title">
                                        <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" data-target="#compQns">
                                            Company : {{recruiterqns.companyName}}&nbsp;&nbsp;<span *ngIf="!checkifCompanyCompleted() && isCompanyQuestionExists" style="color: #ff0000; font-size: 11px">Not Completed</span><span *ngIf="checkifCompanyCompleted() && isCompanyQuestionExists" style="color: #008000; font-size: 11px">Completed</span>
                                        </a>
                                    </h4>
                                </header>
                                <div id="compQns" class="panel-collapse collapse in">
                                    <div class="panel-body">
                                        <div class="d-flex justify-content-end">
                                        </div>
                                        <table width="95%" style="margin-top: 10px;" *ngFor="let companyQuestion of getNonOverallQuestions(recruiterqns.companyQuestionsResults[feedbackQuestionsCompanyId]); let i = index" class="feedback-question-table">
                                            <tr>
                                                <td colspan="2" style="padding-bottom: 25px">
                                                    <span>{{i+1}}. </span>
                                                    <span id="co-qn" *ngIf="!companyQuestion.newQuestionFlag">
                                                        {{companyQuestion.question}}
                                                    </span>
                                                    <span id="co-qn" *ngIf="companyQuestion.newQuestionFlag">
                                                        <input type="text" [(ngModel)]="companyQuestion.question" name="co-qn-text-{{i}}" style="width: 90%">
                                                    </span>
                                                    <span class="pull-right" *ngIf="companyQuestion.newQuestionFlag">
                                                        <i class="fa fa-times" tooltip="Remove Question" (click)="removeQuestion('Company',feedbackQuestionsCompanyId,companyQuestion.id)"></i>
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr [ngClass]="{'disable-element' : feedbackReadOnly}">
                                                <td width="120px">Rating : </td>
                                                <td style="width: 400px;">
                                                    <div class="co-qn-slider" id="co-qn-slider__{{companyQuestion.id}}"></div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td style="text-align: center">
                                                    <span class="slider-label" id="co-qn-rating__{{companyQuestion.id}}">{{companyQuestion.rating}}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="2">
                                                    <div class="d-flex align-items-start">

                                                          <textarea style="resize:none; height: 50px;" class="form-control" id="co-qn-comments{{i + 1}}" name="co-qn-comments-{{i}}" [(ngModel)]="companyQuestion.recruiterComment"
                                                              (ngModelChange)="_onCommentChange()" [readOnly]="feedbackReadOnly" rows="2"></textarea>
                                                    </div>
                                                    <div *ngIf="companyQuestion.recruiterName != null">
                                                        <span class="recorded-by"> Recorded by {{companyQuestion.recruiterName}} on {{companyQuestion.questionareDateTime | fourDotFiveTimeStampFormatPipe }}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>
                                        <table width="95%" [hidden]="feedbackReadOnly || feedbackType == 'Outreach'" style="margin: 10px auto 0px auto">
                                            <tr>
                                                <td>
                                                    <button type="button" class="btn btn-primary pull-right" (click)="addQuestion('Company',feedbackQuestionsCompanyId)">Add Question</button>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <table
                                *ngFor="let clientKey of recruiterqns.sortedClientList; let ci = index" width="100%" style="margin-top: 5px;"
                                [ngClass]="{'disablescreen row-disabled': feedbackType == 'Outreach' && disableFeedbackQuestions }">
                                <tr>
                                    <td style="margin: 0px; padding: 0px">
                                        <div [hidden]="!toDisplayClientPanel(clientKey)">
                                            <div id="{{clientKey}}" class="panel panel-default">
                                                <header class="panel-heading">
                                                    <h4 class="panel-title">
                                                        <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" data-target="#clientQns{{ci}}">
                                                            <span *ngIf="!isCorporateFlag">Client</span>
                                                            <span *ngIf="isCorporateFlag">BU</span>
                                                            : {{recruiterqns.clientDetails[clientKey]}}&nbsp;&nbsp;<span *ngIf="!checkifClientCompleted(clientKey) && checkifClientCompleted(clientKey) != null" style="color: #ff0000; font-size:11px">Not Completed</span><span *ngIf="checkifClientCompleted(clientKey)" style="color: #008000; font-size: 11px">Completed</span>
                                                        </a>
                                                    </h4>
                                                </header>
                                                <div id="clientQns{{ci}}" class="panel-collapse collapse in">
                                                    <div class="panel-body">
                                                        <table width="95%" style="margin-top: 10px;" *ngFor="let clientQuestion of recruiterqns.clientQuestionsResults[clientKey]; let i = index" class="feedback-question-table">
                                                            <tr>
                                                                <td colspan="2" style="padding-bottom: 25px">
                                                                    <span class="cl-qn{{clientKey}}" *ngIf="!clientQuestion.newQuestionFlag">{{i + 1}}. {{clientQuestion.question}}</span>
                                                                    <span class="cl-qn{{clientKey}}" *ngIf="clientQuestion.newQuestionFlag">
                                                                        {{i + 1}}. <input type="text" [(ngModel)]="clientQuestion.question" name="cl-qn-text-{{clientKey}}-{{i}}" style="width: 90%">
                                                                    </span>
                                                                    <span class="pull-right" *ngIf="clientQuestion.newQuestionFlag">
                                                                        <i class="fa fa-times" tooltip="Remove Question" (click)="removeQuestion('Client',clientKey,clientQuestion.id)"></i>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                            <tr [ngClass]="{'disable-element' : feedbackReadOnly}">
                                                                <td width="120px">Rating : </td>
                                                                <td style="width: 400px;">
                                                                    <div class="cl-qn-slider" id="cl-qn-slider__{{clientKey}}__{{clientQuestion.id}}"></div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td></td>
                                                                <td style="text-align: center">
                                                                    <span class="cl-qn-rating slider-label" id="cl-qn-rating__{{clientKey}}__{{clientQuestion.id}}">{{clientQuestion.rating}}</span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="2">
                                                                    <div class="d-flex align-items-start">

                                                                        <textarea style="resize:none; height: 50px;" class="form-control" id="cl-qn-comments{{clientKey}}-{{i + 1}}" name="cl-qn-comments-{{clientKey}}-{{i}}" rows="2" (ngModelChange)="_onCommentChange()" [readOnly]="feedbackReadOnly"
                                                                                  [(ngModel)]="clientQuestion.recruiterComment"></textarea>
                                                                    </div>
                                                                    <div *ngIf="clientQuestion.recruiterName != null">
                                                                        <span class="recorded-by"> Recorded by {{clientQuestion.recruiterName}} on {{clientQuestion.questionareDateTime | fourDotFiveTimeStampFormatPipe }}</span>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                        <table width="95%" [hidden]="feedbackReadOnly || feedbackType == 'Outreach'" style="margin: 10px auto 0px auto">
                                                            <tr>
                                                                <td>
                                                                    <button type="button" class="btn btn-primary pull-right" (click)="addQuestion('Client',clientKey)">Add Question</button>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <!-- Candidate Additional Details -->
                            <table width="100%" style="margin-top: 5px;" *ngIf="showAdditionalCandidateDetailsFlag && !userHasAccessToFeedback">
                                <tr>
                                    <td style="padding: 0px; margin: 0px;">
                                        <div class="panel panel-default">
                                            <header class="panel-heading">
                                                <h4 class="panel-title">
                                                    <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion"
                                                        data-target="#additionalDetails">
                                                        Additional Details
                                                    </a>
                                                </h4>
                                            </header>
                                            <div id="additionalDetails" class="panel-collapse collapse in">
                                                <div class="panel-body">
                                                    <table width="95%" class="feedback-question-table">
                                                        <tr>
                                                            <td colspan="2">
                                                                <app-candidate-additional-details
                                                                    *ngIf="showAdditionalCandidateDetailsFlag"
                                                                    [showSalary]="true"
                                                                    [additionalDetails]="candidateAdditionalDetails">
                                                                </app-candidate-additional-details>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>

                            <table width="100%" style="margin-top: 5px;">
                                <tr>
                                    <td style="padding: 0px; margin: 0px;">
                                        <div class="panel panel-default">
                                            <header class="panel-heading">
                                                <h4 class="panel-title">
                                                    <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" data-target="#overall">
                                                        Overall comments &nbsp;&nbsp;<span *ngIf="!checkifCompanyOverallCompleted()" style="color: #ff0000; font-size: 11px">Not Completed</span><span *ngIf="checkifCompanyOverallCompleted()" style="color: #008000; font-size: 11px">Completed</span>

                                                    </a>
                                                </h4>
                                            </header>
                                            <div id="overall" class="panel-collapse collapse in">
                                                <div class="panel-body">
                                                    <table width="95%" *ngFor="let overallQn of getOverallQuestions(recruiterqns.companyQuestionsResults)" class="feedback-question-table">
                                                        <tr>
                                                            <td colspan="2">
                                                                <span id="overall-qn">{{overallQn.question}}{{onOverallRowInit()}}</span>
                                                                <br/><br/>
                                                            </td>
                                                        </tr>
                                                        <tr [ngClass]="{'disable-element' : feedbackReadOnly}">
                                                            <td width="120px">Rating : </td>
                                                            <td style="width: 400px;">
                                                                <div class="overall-qn-slider" id="overall-qn-slider__{{overallQn.id}}"></div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td></td>
                                                            <td style="text-align: center">
                                                                <span id="overall-qn-rating__{{overallQn.id}}" class="slider-label">{{overallQn.rating}}</span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="2">
                                                                <div class="d-flex align-items-start">

                                                                    <textarea style="resize:none; height: 50px;" class="form-control"
                                                                        id="overall-qn-comments" name="overall-qn-comments" rows="2"
                                                                        [readOnly]="feedbackReadOnly"
                                                                        [(ngModel)]="overallQn.recruiterComment"
                                                                        (ngModelChange)="copyNote && onInternalNoteChanged(); _onCommentChange()">
                                                                    </textarea>
                                                                </div>
                                                                <div *ngIf="overallQn.recruiterName != null">
                                                                    <span class="recorded-by"> Recorded by {{overallQn.recruiterName}} on {{overallQn.questionareDateTime | fourDotFiveTimeStampFormatPipe }}</span>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr *ngIf="candidateJobMatch.isSharedRequisition || externalCommentRequired == 'true'">
                                                            <td colspan="2">
                                                                <app-external-notes
                                                                    [form]="feedbackExecutionForm"
                                                                    [note]="overallQn.recruiterComment"
                                                                    [externalNote]="overallQn.externalComment"
                                                                    [copyNote]="copyNote"
                                                                    addNoteLabel="Add Overall External Comment"
                                                                    copyNoteLabel="Copy Internal Comment to External Comment"
                                                                    externalNoteLabel="Overall External Comment"
                                                                    (onExternalNoteChange)="onExternalNoteChange($event)"
                                                                    (onCopyNoteChange)="onCopyNoteChange($event)"
                                                                    [sourceScreen]="sourceScreen"
                                                                    [formalizeActivityPayload]="formalizeActivityPayload">
                                                                </app-external-notes>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div [hidden]="feedbackReadOnly || feedbackType == 'Outreach'">
                            <div class="mb-3">
                                <app-bulk-formalize
                                    [items]="formalizeItemsArray"
                                    (saveCallback)="handleBulkSave($event)"
                                    [sourceScreen]="sourceScreen"
                                    [candidate]="formalizeActivityPayload ? formalizeActivityPayload.candidate : null"
                                    [company]="formalizeActivityPayload ? formalizeActivityPayload.company : null"
                                    [requisition]="formalizeActivityPayload ? formalizeActivityPayload.requisition : null"
                                    [jobMatch]="formalizeActivityPayload ? formalizeActivityPayload.jobMatch : null">
                                </app-bulk-formalize>
                            </div>

                            <table width="100%">
                                <tr>
                                    <td align="right">
                                        <button type="submit" class="btn btn-success" id="cancelBtn" [disabled]="savingFlag || completingFlag" (click)="cancelModal()">Cancel</button>
                                        <button type="submit" class="btn btn-success ml-2" (click)="saveResults('save')" id="saveBtn" [disabled]="savingFlag || completingFlag">
                                            <span *ngIf="!savingFlag">Save</span>
                                            <span *ngIf="savingFlag">Saving..</span>
                                        </button>
                                        <button type="submit" class="btn btn-success ml-2" (click)="completeModal('complete')" id="completeBtn" [disabled]="completingFlag || savingFlag">
                                            <span *ngIf="!completingFlag">{{completeButtonLabel}}</span>
                                            <span *ngIf="completingFlag && completeButtonLabel == 'Complete'">Completing..</span>
                                            <span *ngIf="completingFlag && completeButtonLabel == 'Update'">Updating..</span>
                                        </button>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div [hidden]="!(feedbackReadOnly && context !== 'candidateJobMatchProfile')">
                            <table width="100%">
                                <tr>
                                    <td align="right">
                                        <button type="submit" class="btn btn-success" id="closeBtn" (click)="closeModal()">Close</button>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class='col-xs-12'
                        *ngIf="recruiterqns && recruiterqns.companyQuestionsResults[feedbackQuestionsCompanyId] && recruiterqns.companyQuestionsResults[feedbackQuestionsCompanyId][recruiterqns.companyQuestionsResults[feedbackQuestionsCompanyId].length-1].externalComment"
                        [hidden]="!(displayQuestions && !loadingFeedbackDetailsFlag && !userHasAccessToFeedback)">
                        <p>Overall Comment: </p>
                        <textarea style="resize:none; height: 50px;" class="form-control" id="overall-qn-comments-readonly" name="overall-qn-comments-readonly" rows="2"
                            [readOnly]="true"
                            [(ngModel)]="recruiterqns.companyQuestionsResults[feedbackQuestionsCompanyId][recruiterqns.companyQuestionsResults[feedbackQuestionsCompanyId].length-1].externalComment">
                        </textarea>
                    </div>
                    <div class='col-xs-12'
                        *ngIf="recruiterqns && recruiterqns.companyQuestionsResults[feedbackQuestionsCompanyId] && !recruiterqns.companyQuestionsResults[feedbackQuestionsCompanyId][recruiterqns.companyQuestionsResults[feedbackQuestionsCompanyId].length-1].externalComment"
                        [hidden]="!(displayQuestions && !loadingFeedbackDetailsFlag && !userHasAccessToFeedback)">
                        <p>No comments provided. </p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Display meeting link -->
        <div class="col-xs-12 py-3" style="font-size: 1.7rem;" *ngIf="showMeetingLink && !loadingFeedbackOptionsFlag">
            The selected schedule's feedback has not yet been completed. If you want to start the feedback, <a href="{{chosenMeeting.meetingUrl}}" target="_blank">Click here</a>.
        </div>
    </div>
</div>
</form>
